/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import Space from 'material/space/space';
import {  } from '@insticator/insticator-ui/dist/material';
import SidePanel from './sidepanel/sidepanel';
import Overlay from './overlay/overlay';
import Inline from './inline/inline';
// styles
import injectSheet from 'react-jss'
import styles from './preview_styles'



/* ========== ~~~~~~~~~~ PRODUCT MANAGER: PAGE SETUP : PREVIEW ~~~~~~~~~~ ========== */
const Preview = injectSheet(styles)((props) => {

  const { 
      showCommenting = false,
      showTrendingNow = false,
      showArticleSentiment = false,
      layout = 'SIDE_PANEL_LEFT', // SIDE_PANEL_LEFT, SIDE_PANEL_RIGHT, OVELAY, INLINE 
      trigger = 'CONTROL_BAR', // CONTROL_BAR, BUTTON, CUSTOM 
      controlBarAlignment = 'TOP',  // TOP, MIDDLE, BOTTOM /  LEFT, CENTERED, RIGHT
      controlBarPlacement = 'RIGHT_EDGE', // LEFT_EDGE, RIGHT_EDGE  /  BOTTOM
      products = ['TRENDING_NOW_V2', 'COMMENTING_V2',  'ARTICLE_SENTIMENT_V2']
  } = props

  const layoutProps = {
    showCommenting,
    showTrendingNow,
    showArticleSentiment,
    layout,
    trigger,
    controlBarAlignment,
    controlBarPlacement,
    products
  }

  return (
    <div className={`preview ${props.classes.preview}`}>
    {(layout === 'SIDE_PANEL_LEFT' || layout === 'SIDE_PANEL_RIGHT') && <SidePanel {...layoutProps} />}
    {layout === 'OVERLAY' && <Overlay {...layoutProps}  />}
    {layout === 'INLINE' && <Inline {...layoutProps}  />}
    </div>
   
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Preview;